module.exports = __webpack_public_path__ + "static/media/3219A3_5_0.84e11a49.ttf";